import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["yahoo", "Yahoo DSP", "Yahoo Gemini"],
  iconColor: "#C825A8", // venus
  getIcon(options) {
    return createIcon(
      `
      <g clip-path="url(#clip0_4513_17905)">
        <path
          d="M9.91478 17.627L13.4614 9.08301H11.1201L9.69078 12.667L8.34678 9.08301H5.94678L8.49611 15.339L7.57878 17.627H9.91478Z"
          fill="#6001D2" />
        <path
          d="M12.3254 13.9949C12.3254 14.7789 12.9334 15.4242 13.7548 15.4242C14.6028 15.4242 15.2374 14.7522 15.2374 13.9469C15.2374 13.1629 14.6294 12.5176 13.8081 12.5176C12.9601 12.5176 12.3308 13.1896 12.3254 13.9949Z"
          fill="#6001D2" />
        <path d="M15.4507 6.3252L13.1094 11.9679H15.7494L18.0907 6.3252H15.4507Z" fill="#6001D2" />
      </g>
      <defs>
        <clipPath id="clip0_4513_17905">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
      `,
      "#F9E9F6", // venus-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
